import React from "react";
import Layout from "../components/Layout";
import CustomScrollbar from "../components/Misc/CustomScrollbar";
import Private from "../components/Auth/Private";
import CreateWallpaperComponent from "../components/CreateWallpaper";
import SEO from "../components/Misc/SEO";

const create = () => {
  return (
    <Layout>
      <SEO title="Create" />
      <Private>
        <div className="inner-content w-100">
          <CustomScrollbar page={true}>
            <CreateWallpaperComponent />
          </CustomScrollbar>
        </div>
      </Private>
    </Layout>
  );
};

export default create;
